import { render, staticRenderFns } from "./TraxTrainingCompetencyDomainsEdit.vue?vue&type=template&id=346c214a"
import script from "./TraxTrainingCompetencyDomainsEdit.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyDomainsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports